import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-commande',
  templateUrl: './commande-param.component.html',
  styleUrls: ['./commande-param.component.scss']
})
export class CommandeParamComponent {
  @HostBinding('class.clamp') clamp = true;
  constructor(
  ) {
  }

  ngOnInit() {
  }
}
